<!-- <vg-player> -->
<video id="intro-video" [muted]="true" #video playsinline width="1366" height="768" class="video">
    <source src="assets/video/intro-llacuna.mp4" type="video/mp4">
</video>
<!-- </vg-player> -->